export function jwtExpiresAt(token: string): string | undefined {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return typeof payload?.exp === 'number' ? new Date(payload.exp * 1000).toISOString() : undefined;
  } catch {
    return undefined;
  }
}
